import { render, staticRenderFns } from "./ItemEditionComponent.vue?vue&type=template&id=9fcf087a&scoped=true"
import script from "./ItemEditionComponent.vue?vue&type=script&lang=js"
export * from "./ItemEditionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcf087a",
  null
  
)

export default component.exports